<template>
  <div class="flex min-h-screen flex-col items-center justify-center">
    <div class="flex w-full max-w-md flex-col gap-2 text-center">
      <div class="relative flex h-12 items-center justify-center bg-primary">
        <Icon.CloudPureLogo height="14" width="134" class="text-white" />
      </div>

      <div>
        <h1 class="text-2xl font-semibold text-gray-900 mb-2">{{ t('sso.redirect-title') }}</h1>

        <button
          @click="manualRedirect"
          class="rounded font-medium text-blue-600 underline hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {{ t('sso.redirect-link') }}
        </button>
      </div>

      <div v-if="hasError" class="mt-6 rounded-lg border border-red-200 bg-red-50 p-4">
        <div class="align-center flex justify-center">
          <span class="text-red-800 text-sm">{{ errorMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Icon } from '@/assets/svg';

const route = useRoute();
const { t } = useI18n();
const hasError = ref(false);
const errorMessage = ref('');

let redirectTimeout: NodeJS.Timeout | null = null;

const buildProtocolUrl = () => {
  const { token, user_uuid, domain, expire, error } = route.query;

  if (error) {
    throw Error(error as string);
  }

  if (!token || !user_uuid || !domain || !expire) {
    throw Error('Missing required authentication parameters');
  }

  return `cloudpure://auth/callback?token=${token}&user_uuid=${user_uuid}&domain=${domain}&expire=${expire}`;
};

const displayError = (error: string) => {
  errorMessage.value = error;
  hasError.value = true;
};

const attemptRedirect = () => {
  try {
    window.location.href = buildProtocolUrl();
  } catch (error) {
    displayError(error instanceof Error ? error.message : t('sso.redirect-error'));
  }
};

const manualRedirect = () => {
  attemptRedirect();
};

onMounted(() => {
  redirectTimeout = setTimeout(() => {
    attemptRedirect();
  }, 1_000);
});

onUnmounted(() => {
  if (redirectTimeout) {
    clearTimeout(redirectTimeout);
  }
});
</script>
